import { ImagePlus } from 'lucide-react';
import { useRef } from 'react';
import type { UploadProgress } from '@/shared/hooks/useUploadQueue';
import { Button } from './Button';

interface Props {
  /** Beschriftung im Ruhezustand, etwa „Bilder hinzufügen“. */
  label: string;
  onFiles: (files: File[]) => void;
  /** Läuft ein Upload, zeigt der Knopf, bei welcher Datei er ist, und nimmt keine neuen an. */
  progress: UploadProgress | null;
  disabled?: boolean;
  accept?: string;
  variant?: 'ghost' | 'brand';
  className?: string;
}

/** Wählt mehrere Bilder auf einmal — die Verwaltung pflegt selten nur eines. */
export function ImagePickerButton({
  label,
  onFiles,
  progress,
  disabled,
  accept = 'image/jpeg,image/png,image/webp',
  variant = 'ghost',
  className,
}: Props) {
  const picker = useRef<HTMLInputElement>(null);
  return (
    <>
      <input
        ref={picker}
        type="file"
        accept={accept}
        multiple
        className="hidden"
        aria-label={label}
        onChange={(event) => {
          const files = event.target.files ? Array.from(event.target.files) : [];
          event.target.value = '';
          if (files.length > 0) onFiles(files);
        }}
      />
      <Button
        type="button"
        size="sm"
        variant={variant}
        className={className}
        leftIcon={<ImagePlus size={14} strokeWidth={2} />}
        loading={progress !== null}
        disabled={disabled || progress !== null}
        onClick={() => picker.current?.click()}
      >
        {progress ? `Lade ${progress.current} von ${progress.total} …` : label}
      </Button>
    </>
  );
}
